import React, { useState, useRef } from "react";
import classNames from "classnames/bind";
import useSWR from "swr";

import { ReactComponent as Info } from "../../icons/info.svg";

import { Button } from "../Button";
import { FrequencyList } from "../FrequencyList";

import styles from "./Tutorial.module.css";
import { CATEGORIES } from "api/categories";
import { useEffect } from "react";

const cx = classNames.bind(styles);

type Props = {
  onHide: () => void;
};

const phases = [0, 1000, 2000, 2300, 2800, 3800, 4000, 4800, 7000];

export const Tutorial: React.FC<Props> = ({ onHide }) => {
  const list = useRef<HTMLDivElement>(null);
  const { data: frequencies = [] } = useSWR<
    {
      key: string;
      custom_частота: string;
    }[]
  >([CATEGORIES.FREQUENCY, 86]);
  const [activeKey, setActiveKey] = useState<string>();
  const [phase, setPhase] = useState<number>(0);

  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const now = (Date.now() - start) % 8000;
      const nextPhase = phases.findIndex((item) => now < item);
      const newPhase = nextPhase === -1 ? phases.length - 1 : nextPhase - 1;

      setPhase(newPhase);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (list?.current) {
      if (phase === 2) {
        list.current.scrollLeft = 116;
      }

      if (phase === 5) {
        setActiveKey(frequencies[0]?.key);
      }

      if (phase === 8) {
        list.current.scrollLeft = 0;
        setActiveKey(undefined);
      }
    }
  }, [phase]);

  return (
    <div className={cx("overlay")}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Info width={24} height={24} className="" />
        <div className={cx("overlay__text")}>
          Выберите частоту употребления
          <br /> порции проматывая список <br /> значений по горизонтали
        </div>
        <div className={cx("overlay__button")}>
          <Button
            onClick={onHide}
            color="cerulean"
            block
            size="medium"
            rounded
            type="button"
          >
            Понятно
          </Button>
        </div>
      </div>

      <div className={cx("arrow")}>
        <div className={cx("chevron")}></div>
        <div className={cx("chevron")}></div>
        <div className={cx("chevron")}></div>
      </div>

      <div
        className={cx("swiper", {
          [`swiper__${phase}`]: phase,
        })}
      >
        &nbsp;
      </div>
      <div className={cx("list")}>
        <FrequencyList
          items={frequencies}
          onSubmit={() => null}
          onChange={() => null}
          ref={list}
          activeKey={activeKey}
        />
      </div>
    </div>
  );
};
